import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BcmApiService } from '@bcmApiServices/bcm-api.service';
import { PrintJobCreateResponse, PrintJobRequest } from '@shared/models/receipt-data';

@Injectable({providedIn: 'root'})
export class PrintJobsApiService extends BcmApiService {

    create(body: PrintJobRequest): Observable<PrintJobCreateResponse> {
        return super.post<PrintJobCreateResponse>('print-jobs', body);
    }
}
